var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoGuides(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    stroke: "#2C67F1",
    fill: "none",
    strokeWidth: 2.8,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 10.948C11.25 10.2321 11.25 9.87411 11.3996 9.67427C11.53 9.50011 11.7296 9.39115 11.9466 9.37565C12.1956 9.35787 12.4967 9.55144 13.0989 9.93858L20.1798 14.4906C20.7024 14.8265 20.9637 14.9945 21.0539 15.2081C21.1328 15.3947 21.1328 15.6053 21.0539 15.7919C20.9637 16.0055 20.7024 16.1735 20.1798 16.5094L13.0989 21.0614C12.4967 21.4486 12.1956 21.6421 11.9466 21.6243C11.7296 21.6088 11.53 21.4999 11.3996 21.3257C11.25 21.1259 11.25 20.7679 11.25 20.052V10.948Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 9.2C1.5 6.67976 1.5 5.41965 1.99047 4.45704C2.4219 3.61031 3.11031 2.9219 3.95704 2.49047C4.91965 2 6.17976 2 8.7 2H21.3C23.8202 2 25.0804 2 26.043 2.49047C26.8897 2.9219 27.5781 3.61031 28.0095 4.45704C28.5 5.41965 28.5 6.67976 28.5 9.2V21.8C28.5 24.3202 28.5 25.5804 28.0095 26.543C27.5781 27.3897 26.8897 28.0781 26.043 28.5095C25.0804 29 23.8202 29 21.3 29H8.7C6.17976 29 4.91965 29 3.95704 28.5095C3.11031 28.0781 2.4219 27.3897 1.99047 26.543C1.5 25.5804 1.5 24.3202 1.5 21.8V9.2Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoGuides);
export default __webpack_public_path__ + "static/media/video-guides.00f80eba7b3f8d248db2f55ee13d6419.svg";
export { ForwardRef as ReactComponent };